const MixPanelEventos = {
  ESCOLHA_MEDICO_ESPECIALIDADE: 'Escolher Especialidade e/ou Medico',
  ESCOLHA_LOCAL: 'Escolher Local',
  INFORMAR_DADOS_PESSOAIS: 'Informar Dados Pessoais',
  ESCOLHER_FORMA_PAGAMENTO: 'Escolher Forma de Pagamento',
  EXIBIR_ERRO_ELEGIBILIDADE: 'Exibir Erro de Elegibilidade',
  CONSULTAR_PRECO_CONSULTA: 'Consultar Preco da Consulta',
  FILTRAR_HORARIOS: 'Filtrar Horarios',
  TENTATIVA_LOGIN: 'POC Tentativa Login',
  RETORNO_LOGIN: 'POC Retorno Login',
  ABRIR_ATENDIMENTO_CHAT: 'Abrir Atendimento via Chat',
  ESCOLHER_HORARIOS: 'Escolher Horarios',
  FINALIZAR_CADASTRO: 'Finalizar Cadastro',
  CANCELAR_AGENDAMENTO: 'Cancelar Agendamento',
  ACESSAR_ESPERA: 'Acessar sala de espera de teleconsulta',
  ACESSAR_TELECONSULTA: 'Entrar sala de teleconsulta',
  LISTAR_HORARIOS: 'Listar Horarios',
  VERIFICAR_COBERTURA: 'Verificar Cobertura',
  EXIBIR_ERRO: 'Exibir Erro Generico',
  ARMAZENAR_ERRO_GENERICO: 'Armazenar Erro Generico',
  PERMITIR_GEO_LOCALIZACAO: 'Permitir localizacao',
  BLOQUEAR_GEO_LOCALIZACAO: 'Negar localizacao',
  ATIVAR_TOGGLE_GEO_LOCALIZACAO: 'Ativar o uso da Geo',
  DESATIVAR_TOGGLE_GEO_LOCALIZACAO: 'Desativar o uso da Geo',
  GEO_LOCALIZACAO_MODAL_FOI_EXIBIDO: 'Exibir instrucoes para ativar Geo',
  CLICOU_NA_SUGESTAO_LOCAL: 'Selecionar sugestoes',

  ADICIONAR_AGENDA: 'Adicionar à Agenda'
}

export default MixPanelEventos
